import useService from './serviceHook';

export default useService;
